import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Grid from '@mui/material/Grid2';

import { 
  FeatureSource,
  ModelBase,
  PlayerObject,
} from "@models";
import {  
  WEAPON_KEYWORD_OPTIONS,
  WeaponMasteryProperty, 
} from "@dndModels";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import LoadingBox from "@components/input/LoadingBox";
import FeatureSourceInput from "@dndComponents/FeatureSourceInput";
import SelectStringBox from "@components/input/selects/SelectStringBox";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function WeaponMasteryPropertyEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [obj, setObj] = useState<WeaponMasteryProperty>(api.applyWorkingOn(new WeaponMasteryProperty()));
  const [change_time, setChangeTime] = useState(0);
  
  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);
  
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const load = () => {
    if (id && id !== "") {
      setLoading(true);
      const onComplete = (res: PlayerObject[] | ModelBase[]) => {
        if (res.length === 1 && res[0] instanceof WeaponMasteryProperty) {
          const new_obj = res[0];
          setObj(new_obj.clone() as WeaponMasteryProperty);
          setChangeTime(common_util.get_time_number());
        }
        setLoading(false);
      };
      const onProgress = () => {};
      api.getObjectsWithCallbacks({ 
        data_type: "weapon_mastery_property", filter: { _id: id },
        onComplete, onProgress 
      });
    }
    
    setFetched(true);
  }

  // const submit = () => {
  //   if (api.user && 
  //     (api.user.admin || 
  //       obj._id === "" || 
  //       obj.owner_id === api.user._id)) {
  //     setProcessing(true);
  //     if (!api.user.admin || obj.source_books_old.filter(o => o.id === "Personal").length > 0) {
  //       obj.owner_id = api.user._id;
  //     } else if (api.user.admin && obj.source_books_old.filter(o => o.type === "Homebrew").length === 0) {
  //       obj.owner_id = "";
  //     }
  //     api.upsertObject("weapon_mastery_property", obj).then(res => {
  //       setProcessing(false);
  //       setNavigateTo("/dandd/weapon_mastery_property");
  //     });
  //   }
  // }

  const height = window.innerHeight - 64;
  if (!fetched || loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else {
    return (
      <FeatureSourceInput 
        obj={obj}
        data_type="weapon_mastery_property"
        disabled={disabled}
        change_time={change_time}
        onChange={(changed: FeatureSource) => {
          if (changed instanceof WeaponMasteryProperty) {
            const new_obj = obj;
            new_obj.copy(changed);
            setObj(new_obj);
            setChangeTime(common_util.get_time_number());
          }
        }}
        extra_menu_options={{"Attributes": 
          <Grid
            container
            spacing={0}
            direction="row"
            size={{
              xs: 12
            }}>
            <Grid
              size={{
                xs: 12
              }}>
              There are two sets of keywords.  If both are used then at least one keyword from each must be met.
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <SelectStringBox
                name="Required Weapon Keywords Set 1"
                options={WEAPON_KEYWORD_OPTIONS}
                values={obj.required_weapon_keyword_ids}
                multiple
                onChange={(ids: string[]) => {
                  const new_obj = obj;
                  new_obj.required_weapon_keyword_ids = ids;
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <SelectStringBox
                name="Required Weapon Keywords Set 2"
                options={WEAPON_KEYWORD_OPTIONS}
                values={obj.required_weapon_keyword_ids2}
                multiple
                onChange={(ids: string[]) => {
                  const new_obj = obj;
                  new_obj.required_weapon_keyword_ids2 = ids;
                  setObj(new_obj);
                  setChangeTime(common_util.get_time_number());
                }}
              />
            </Grid>
          </Grid>
        }}
      />
    );
  }
}
